import type {HotelDetails} from '@/api/hoteldetails';
import type {
  FilterParams,
  SortParams,
} from '@/modules/common/context/QueryParams/models';
import type {HotelListLoadedEvent} from '@/redux/middleware/googleTagManager/types';
import type {Hotel} from '@/redux/v1/hotels/list/models';

import {mapHotelDataToEcommerceItem} from '@/redux/middleware/googleTagManager/utils/hotelData';
import {mapFilterParamsToGTMEvent} from '@/redux/middleware/googleTagManager/utils/mapFilterParams';
import {mapHotelChangeActionToEvent} from '@/redux/middleware/googleTagManager/utils/mapHotelChangeActionToEvent';

type Options = {
  lazy: boolean;
  origin?: 'sort' | 'filter' | 'search';
  destinationId: string;
  filterParams: FilterParams;
  sortParams: SortParams;
  hotels: Array<{
    position: number;
    offer?: Hotel;
    data?: HotelDetails;
  }>;
  hotelsCount: number;
};

export const hotelListLoadedEvent = ({
  origin,
  lazy,
  filterParams,
  destinationId,
  hotelsCount,
  hotels,
  sortParams,
}: Options): HotelListLoadedEvent => {
  return [
    {ecommerce: null},
    {
      event: 'view_item_list',
      event_action: mapHotelChangeActionToEvent(origin, lazy),
      ...mapFilterParamsToGTMEvent(filterParams),
      // @FIXME should be the destination name
      term: destinationId,
      non_interaction: !origin,
      hotel_list_offset: hotelsCount,
      ecommerce: {
        items: hotels.map(({position, offer, data}) =>
          mapHotelDataToEcommerceItem(
            {
              id: offer?.id ?? '',
              price: offer?.totalPrice ?? {amount: 0, currency: ''},
              position,
              specials: offer?.tourOperatorSpecials,
              ratingScore: offer?.rating?.rating ?? null,
            },
            String(sortParams.sortBy),
            data
          )
        ),
      },
    },
  ];
};
